import React from 'react';

const Vue_v_else_if = () => {
  return (
    <div>
      <h1>Vue_v_else_if Component</h1>
      <p>This is the Vue_v_else_if tutorial page.</p>
    </div>
  );
}

export default Vue_v_else_if;
